/**
 * Core Radio Group — wraps Radix RadioGroup for accessibility.
 */
import React from 'react';
import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { cn } from '@/lib/utils';

export interface RadioOption { value: string; label: string; disabled?: boolean; }

export interface RadioGroupProps {
  value?: string;
  onValueChange?: (value: string) => void;
  options: RadioOption[];
  orientation?: 'horizontal' | 'vertical';
  className?: string;
  name?: string;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({ value, onValueChange, options, orientation = 'vertical', className, name }) => (
  <RadixRadioGroup.Root value={value} onValueChange={onValueChange} name={name} className={cn("flex gap-3", orientation === 'horizontal' ? 'flex-row' : 'flex-col', className)}>
    {options.map((opt) => (
      <div key={opt.value} className="flex items-center gap-2">
        <RadixRadioGroup.Item
          value={opt.value}
          disabled={opt.disabled}
          className="h-4 w-4 rounded-full border border-slate-300 dark:border-slate-600 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-[var(--primary-color)]"
        >
          <RadixRadioGroup.Indicator className="flex items-center justify-center">
            <div className="h-2 w-2 rounded-full bg-[var(--primary-color)]" />
          </RadixRadioGroup.Indicator>
        </RadixRadioGroup.Item>
        <label className="text-sm text-gray-700 dark:text-slate-300 cursor-pointer select-none">{opt.label}</label>
      </div>
    ))}
  </RadixRadioGroup.Root>
);
export default RadioGroup;
